<template>
  <div class='StepOne'>
    <div class="cont-form">
      <InitTitle 
      text="Suas credenciais"
      desc="Preencha com os dados de acesso a plataforma."
      />
      <div class="cont">
        <InitInput
        label="Nome"
        :value="payload.nome"
        @returnValue="newValue => {
          $emit('updateProp', { key: 'nome', value: newValue })
          $emit('updateProp', { key: 'usuario', value: toUsuario(newValue) })
        }"
        :error="verify.nome.$invalid"
        />
      </div>
      <div class="cont">
        <InitInput
        label="Sobrenome"
        :value="payload.sobrenome"
        @returnValue="newValue => { 
          $emit('updateProp', { key: 'sobrenome', value: newValue })
          $emit('updateProp', { key: 'usuario', value: toUsuario(payload.nome + '.' + newValue) })
        }"
        :error="verify.sobrenome.$invalid"
        />
      </div>
      <div class="cont">
        <InitInput
        label="Usuário (mínimo 4 caracteres)"
        :value="payload.usuario"
        @returnValue="newValue => $emit('updateProp', { key: 'usuario', value: newValue })"
        :error="verify.usuario.$invalid"
        :errorMsg="verify.usuario.formato.$invalid ? verify.usuario.formato.$message : verify.usuario.has.$invalid ? verify.usuario.has.$message : ''"
        />
      </div>
      <div class="cont">
        <InitInput
        label="Email"
        :value="payload.email"
        @returnValue="newValue => $emit('updateProp', { key: 'email', value: newValue })"
        :error="verify.email.$invalid"
        :errorMsg="verify.email.has.$invalid ? verify.email.has.$message : ''"
        />
      </div>
      <div class="cont">
        <InitInput
        width="48.5%"
        label="Senha"
        :value="payload.senha"
        @returnValue="newValue => $emit('updateProp', { key: 'senha', value: newValue })"
        password
        :error="verify.senha.$invalid"
        />
        <InitInput
        width="48.5%"
        label="Confirmar senha"
        :value="payload.csenha"
        @returnValue="newValue => $emit('updateProp', { key: 'csenha', value: newValue })"
        password
        :error="verify.csenha.$invalid"
        />
      </div>
      <div class="cont-next">
        <button v-if="!load" @click="$emit('changeView', 'StepThree')">Voltar</button>
        <button v-if="!load" @click="next">Próximo</button>
        <VueSpinner v-if="load" size="40"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InitInput from './InitInput'
import InitTitle from './InitTitle'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
import { VueSpinner } from 'vue3-spinners'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'StepOne',
  components: { InitInput, InitTitle, VueSpinner },
  props: ['payload'],
  data () {
    return {
      load: false,
      message: '',
      verify: {
        nome: { $invalid: false },
        sobrenome: { $invalid: false },
        usuario: { $invalid: false, formato: { $invalid: false, $message: '' }, has: { $invalid: false, $message: '' } },
        email: { $invalid: false, has: { $invalid: false, $message: '' } },
        senha: { $invalid: false },
        csenha: { $invalid: false }
      }
    }
  },
  computed: {
    nome () {
      return this.payload.nome
    },
    sobrenome () {
      return this.payload.sobrenome
    },
    usuario () {
      return this.payload.usuario
    },
    email () {
      return this.payload.email
    },
    senha () {
      return this.payload.senha
    },
    csenha () {
      return this.payload.csenha
    }
  },
  validations () {
    return {
      nome: {
        required
      },
      sobrenome: {
        required
      },
      usuario: {
        required,
        minLength: minLength(4),
        formato: helpers.withMessage('Usuário não pode conter espaços ou caracteres especiais', helpers.regex(/^[a-zA-Z0-9._-]+$/)),
        has: helpers.withMessage('Usuário já cadastrado no sistema', helpers.withAsync(this.userHas))
      },
      email: {
        required,
        email,
        has: helpers.withMessage('E-mail já cadastrado no sistema', helpers.withAsync(this.emailHas))
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        required,
        minLength: minLength(6),
        sameAs: (s) => s === this.senha
      },
    }
  },
  methods: {
    ...mapActions(['VerifyUserEmailHas', 'createCompany']),
    async next () {
      let valid = await this.v$.$validate()
      if(!valid) {
        this.verify = this.v$
        return
      }
      //this.$emit('changeView', 'StepTwo')
      this.push()
    },
    toUsuario (str) {
      return (str || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '.')
        .replace(/[^a-z0-9._-]/g, '')
    },
    async userHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.user) },
    async emailHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.email) },
    async push () {
      this.load = true
      this.createCompany(this.payload)
        .then(res => {
          if(!res.status) {
            this.load = false
            this.message = res.message
          }
          else {
            window.location.replace(`https://${this.payload.subdominio}.enobairro.com`)
            //window.location.replace(`http://${this.payload.subdominio}.localhost:8080`)
          }
        })
    }
  }
}
</script>

<style scoped>
.cont-form {
  width: 94%;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 3px 0.05px #B3B3B3;
  padding: 3%;
}

.cont {
  display: flex;
  justify-content: space-between;
  padding-top: 2%;
}

.cont-sub {
  display: flex;
  align-items: end;
  padding: 1.5%;
}

.cont-dominio {
  display: flex;
  padding: 2%;
  padding-left: 0;
  margin-left: 1%;
}

.cont-next {
  padding-top: 2%;
}

button {
  border: 0;
  margin-top: 3%;
  padding: 11px;
  border-radius: 5px;
  background-color: #0E1E2B;
  color: #FFFFFF;
  cursor: pointer;
  margin: 2%;
  font-size: 18px;
}

</style>
